// material
import {
    Stack, 
    Typography, 
    //Drawer, 
    Container, 
    IconButton
} from '@mui/material';

import {
    Dialog,
    DialogClose,
    DialogContent,
    DialogDescription,
    DialogHeader,
    DialogTitle,
    DialogTrigger,
  } from "src/@/components/ui/dialog"

import { Button } from 'src/@/components/ui/button';

import 'react-phone-number-input/style.css'
import { useState, forwardRef } from 'react';
import Iconify from 'src/components/Iconify';
import ModalAlerta from 'src/components/modal/ModalAlerta';
import PhoneInput from 'react-phone-number-input'
import { borderRadius } from 'react-toast-notifications/dist/ToastElement';
import NovoContatoForm from 'src/sections/@dashboard/cadastro/NovoContatoForm';
import v2_actionCriarContato from 'src/actions/v2/contatos/v2_actionCriarContato';
import { validarNumeroWhatsapp } from 'src/utils/functions';
import { useSnackbar } from 'notistack';
import { getBuscarContatos } from 'src/redux/slices/contatos';
import { useDispatch } from 'react-redux';
import HeaderDrawer from 'src/components/modal/HeaderDrawer';


export default function ModalNovoContato({
    user,
    cliente,
    open,
    listaClientesCanais,
    loading,
    callbackAddContact,
    onClose
}) {
    const { enqueueSnackbar } = useSnackbar();
    const [loadingNovoContato, setLoadingNovoContato] = useState(false);
    const [openModalAlerta, setOpenModalAlerta] = useState(false);
    const [mensagemModalAlerta, setMensagemModalAlerta] = useState('');
    const dispatch = useDispatch();

    async function handleCriarContato(data) {
        const { contato, endereco, camposPersonalizados } = data;

        setLoadingNovoContato(true);

        try {
            const requestData = {
                scope: {
                    nome: contato.nome,
                    telefone: validarNumeroWhatsapp(contato.telefone),
                    info: {
                        email: contato.email,
                        cpf: contato.cpf,
                        dataNascimento: contato.dataNascimento,
                        endereco,
                    },
                    custom_fields: camposPersonalizados,
                },
                cliente_id: cliente._id,
                usuario_id: user.id,
                checkExistContact: true,
            };

            const response = await v2_actionCriarContato(requestData);
            if (response.status === 200) {
                if (response.data.error && response.data.codError === 'CONTACT_EXIST') {
                    setMensagemModalAlerta('Já existe um contato com esse número de telefone');
                    setOpenModalAlerta(true);
                    setLoadingNovoContato(false);
                    return;
                }

                setLoadingNovoContato(false);
                onClose();
                enqueueSnackbar('Contato criado com sucesso', { variant: 'success' });
                dispatch(getBuscarContatos(cliente._id));
                callbackAddContact(response.data.data);
            }
        } catch (error) {
            console.error(error);
            setLoadingNovoContato(false);
            enqueueSnackbar('Erro ao criar contato', { variant: 'error' });
        }
    }

    return (
        <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="min-w-[700px]">
            <DialogClose onClick={onClose} />
            <DialogHeader>
                <Typography variant="h5">Cadastrar Contato</Typography>
            </DialogHeader>
      
                {openModalAlerta && (
                    <div className="alert alert-error">
                        <Typography>{mensagemModalAlerta}</Typography>
                        <Button onClick={() => setOpenModalAlerta(false)}>Fechar</Button>
                    </div>
                )}

                <Stack className="space-y-4 mt-4">
                    <NovoContatoForm
                        cliente={cliente}
                        showSaveButton={false}
                        hideSelectEmpresa={true}
                        showSignupButton={true}
                        loadingNovoContato={loadingNovoContato}
                        callbackAddContact={handleCriarContato}
                    />
                </Stack>
    
        </DialogContent>
    </Dialog>
    );
}